import { useEffect, useState } from 'react';
import { useOnce } from '@frontend/web/lib/useOnce';
import { useSignInGateSelector } from '@frontend/web/lib/useSignInGateSelector';
/**
 * @description
 * A custom hook to determine if a sign in gate will show on the current page
 * @param {Boolean} isSignedIn - Is the user signed in to the guardian
 * @param {CAPIBrowserType} CAPI - The CAPI object
 * */
export const useSignInGateWillShow = ({ isSignedIn, contentType, sectionName, tags, isPaidContent, isPreview, }) => {
    const [gateVariant, setGateVariant] = useState(undefined);
    const [currentTest, setCurrentTest] = useState(undefined);
    const [canShowGate, setCanShowGate] = useState(false);
    const gateSelector = useSignInGateSelector();
    useOnce(() => {
        const [gateSelectorVariant, gateSelectorTest] = gateSelector;
        setGateVariant(gateSelectorVariant);
        setCurrentTest(gateSelectorTest);
    }, [gateSelector]);
    useEffect(() => {
        if (gateVariant && currentTest) {
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            gateVariant
                ?.canShow({
                isSignedIn: !!isSignedIn,
                currentTest,
                contentType,
                sectionName,
                tags,
                isPaidContent,
                isPreview,
            })
                .then(setCanShowGate);
        }
    }, [
        currentTest,
        gateVariant,
        isSignedIn,
        contentType,
        sectionName,
        tags,
        isPaidContent,
        isPreview,
    ]);
    return canShowGate && !!gateVariant && !!gateVariant.gate;
};
